module.exports = __webpack_public_path__ + "static/media/item_2_9.b5d1a974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_9.png
// module id = 116
// module chunks = 0